module.exports = __webpack_public_path__ + "static/img/nav_bg_fixed.52719c43.png";